import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { lazy, Suspense } from 'react';

const Home = lazy(() => import('./home/Home'));
const Category = lazy(() => import('./category/Category'));
const Categories = lazy(() => import('./categories/Categories'));
const EquipmenClass = lazy(() => import('./equipment-class/EquipmenClass'));
const Search = lazy(() => import('./search/Search'));

function PrimaryRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path='/'
          element={
            <Suspense fallback={null}>
              <Home />
            </Suspense>
          }
        />
        <Route
          path='/rent'
          element={
            <Suspense fallback={null}>
              <Category />
            </Suspense>
          }
        />
        <Route
          path='/rent/categories/*'
          element={
            <Suspense fallback={null}>
              <Categories />
            </Suspense>
          }
        />
        <Route
          path='/rent/equipment-classes/*'
          element={
            <Suspense fallback={null}>
              <EquipmenClass />
            </Suspense>
          }
        />
        <Route
          path='/search'
          element={
            <Suspense fallback={null}>
              <Search />
            </Suspense>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default PrimaryRouter;
